export const career = [
    {
        id: 1,
        company: "CARFAX",
        location: "London, ON",
        period: "5th February 2024 - Present",
        profile: "Software Engineer",
        desc: [
            "Led the architecture and built React-compatible Preact microfrontend applications within a Lerna/pnpm monorepo, establishing a scalable frontend architecture that enables independent development, testing, and deployment, improving maintainability and team autonomy.",
            "Served as a technical mentor and Subject Matter Expert for engineers and new joiners, accelerating onboarding and driving cross-team adoption of shared infrastructure, distribution platforms, and modern frontend patterns.",
            "Implemented a Vite-based build system for microfrontend applications, generating optimized JavaScript bundles integrated into CI/CD pipelines to support consistent and reliable deployments",
            "Designed and implemented a manifest-based frontend distribution platform in TypeScript that standardizes deployment conventions across 18 applications, reducing developer deployment and coordination efforts by ~90%.",
            "Designed and maintained deployment CI/CD pipelines connecting microfrontend repositories to the distribution platform, streamlining release workflows and reducing deployment complexity across teams.",
            "Implemented a shared pub-sub npm package establishing cross-application communication conventions and reusable abstractions that enabled independently developed frontend applications to operate as a cohesive user experience and built a comprehensive document for ease of its consumption.",
            "Developed a shared observability and instrumentation package using New Relic, standardizing monitoring across microfrontend applications and providing reusable APIs and scaffolding.",
            "Implemented a healthy unit test coverage for frontend components using Jest and automated the test runs on every commit using Husky + Lint-staged, and in the GitLab pipelines for every commit and merge request.",
            "Collaborated closely with product managers and designers in an agile project to deliver customer-facing React and Next.js experiences for the CARFAX account page, including complex features, account management workflows, frontend experimentation via Optimizely, and user interaction analytics through Adobe Analytics. Implemented clean stylesheets using modular SCSS.",
            "Created a Node.js/Fastify service powering personalized vehicle recommendations for hundreds of thousands of daily users, enabling experimentation and targeted experiences that contributed to a 20% increase in dealer-led traffic. Added an integration test suite that runs on the deployed environment to check the functionality and automated Promote and Rollback jobs based on the test result.",
            "Developed reusable AI Agent Skills distributed through Agent Package Manager (APM) to orchestrate AWS EKS migration workflows, reducing migration time by ~80% while standardizing and validating engineering processes across teams.",
            "Implemented CDK for provisioning AWS resources like SQS, SNS, EventBridge, Lambda, DynamoDB, Secret Manager, and IAM Roles.",
        ],
    },
    {
        id: 2,
        company: "Conestoga College",
        location: "Waterloo and Brantford, ON",
        period: "10th January 2024 - 20th December 2024",
        profile: "Professor (part-time)",
        desc: [
            "Taught Advanced Full Stack Development covering React, GraphQL, and AWS - reinforcing the mentorship and technical knowledge-sharing developed throughout my engineering career.",
        ],
    },
    {
        id: 3,
        company: "Longbow Advantage",
        location: "Mississauga, ON",
        period: "26th September 2022 - 8th May 2023",
        profile: "UI Developer",
        desc: [
            "Worked with Product Development Manager on the product's feature development and bug resolution.",
            "Maintained stylesheets and created optimizations.",
            "Developed test cases for backend services using Jest.",
            "Implemented pre-commit hooks forthe front-end repository to maintain code standards.",
            "The technologies used were Javascript, Typescript, SCSS, Angular/JS, SQL, MongoDB, and GraphQL.",
        ],
    },
    {
        id: 4,
        company: "Media.net Software Services",
        location: "Mumbai",
        period: "6th August 2019 - 30th April 2021",
        profile: "Senior UI Developer",
        desc: [
            "Optimized several functionalities using vanilla JavaScript.",
            "Worked on an internal dashboard tool(Datachimp) using ReactJS for front-end, Redux for state management, and Jest for writing test cases.",
            "Contributed to developing new features and improvements of another dashboard (Console) using Angular 6+.",
            "Participated in code reviews.",
        ],
    },
    {
        id: 5,
        company: "Accenture Solutions",
        location: "Mumbai",
        period: "1st October 2018 - 5th August 2019",
        profile: "Web Developer",
        desc: [
            "Implemented and maintained websites for Sanofi, a renowned pharmaceutical company using Sitecore.",
            "Contributed to the continuous improvement of software development by participating in brainstorming sessions with the tech lead.",
            "The technologies used were Sitecore, JQuery, HTML, and LESS.",
        ],
    },
    {
        id: 6,
        company: "Media.net Software Services",
        location: "Mumbai",
        period: "9th May 2016 - 28th September 2018",
        profile: "Jr. UI Developer",
        desc: [
            "Implemented various ad units e.g. keyword ad blocks, interstitials, and SERPs(Search Engine Result Pages) while providing cross browser support",
            "Develope dmarketing material e.g. landing,thank you pages, and product dashboards for browser extensions.",
            "The technologies used were HTML, CSS, and JavaScript.",
        ],
    },
];
